<template>
  <section>
    <div class="row px-4">
      <button @click="refresh()" class="btn btn-sm btn-primary float-right"><i class="icon-refresh"></i></button>
    </div>
    <div class="row">
      <div class="col-md-6 text-center">
        <div class="card mb-2">
          <div class="m-3">
            <h5>Campaigns supply</h5>
            <LoadingOliver v-if="loading" />
            <div class="mt-2">
              <ContactsSupplyChart :dataValues="metrics" v-if="!loading2"> </ContactsSupplyChart>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6 text-center">
            <div class="card mt-2 mb-2 p-3">
              <h5>Contacts success found last 24hs</h5>
              <LoadingOliver v-if="loading2" />
              <h2 v-else :class="{ 'alert-danger': isLowSearchingRate(searching_rate) }">
                {{ searching_rate }}%
                <i v-if="isLowSearchingRate(searching_rate)" class="fas fa-exclamation-circle"></i>
                <i v-else class="fas fa-check-circle"></i>
              </h2>
            </div>
          </div>
          <div class="col-md-6 text-center">
            <div class="card mt-2 mb-2 p-3">
              <h5>Pending Call Cold Tasks</h5>
              <LoadingOliver v-if="loading2" />
              <h3 v-else :class="{ 'alert-danger': isLowPendingColdTask(pending_cold_tasks) }">
                {{pending_cold_tasksks}}
                <i v-if="isLowPendingColdTask(pending_cold_tasks)" class="fas fa-exclamation-circle"></i>
              </h3>
            </div>
          </div>
          <div class="col-md-6 text-center">
            <div class="card mt-3 mb-2 p-3">
              <h5>Domain creation pending</h5>
              <LoadingOliver v-if="loading2" />
              <h3 v-else>{{result.domain_buy}}</h3>
            </div>
          </div>

          <div class="col-md-6 text-center">
            <div class="card mt-3 mb-2 p-3">
              <h5>Zapmail mailbox creation pending</h5>
              <LoadingOliver v-if="loading2" />
              <h3 v-else>{{result.zapmail_pending}}</h3>
            </div>
          </div>

          <div class="col-md-6 text-center">
            <div class="card mt-3 mb-2 p-3">
              <h5>Full Enrich Credits</h5>
              <LoadingOliver v-if="loading2" />
              <h2 v-else :class="{ 'alert-danger': isLowEnrichCredits(balanceEnrich) }">
                {{ balanceEnrich.toLocaleString() }}
                <i v-if="isLowEnrichCredits(balanceEnrich)" class="fas fa-exclamation-circle"></i>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { campaignsService } from "@/_services";
import { mapState, mapActions } from "vuex";
import { statusBadgeMixin, urlMixin, logoMixin } from "@/_mixins/";
import { billingsService, clientsService } from "@/_services";
import LoadingOliver from "@/components/LoadingOliver.vue";
import ContactsSupplyChart from "@/components/SearchSituation/ContactsSupplyChart.vue";

export default {
  data() {
    return {
      metrics: {
        avg: 64,
        p30: 26,
        p50: 100,
        p70: 100,
        total_accounts: 5906,
        total_targets: 947,
        total_t_salesridge: 818
      },
      campaigns: false,
      loading: true,
      result: false,
      loading2: true,
      hour: 1,
      searching_rate: false,
      speedoMeterValue: false,
      balanceEnrich: 0,
    };
  },
  created() {
    this.refresh();
  },
  props: {},
  methods: {
    refresh(){
    this.loading = true;
    this.loading2 = true;
      campaignsService.getContactsFound(3, 3).then((res) => {
        this.loading = false;
        this.speedoMeterValue = res.contacts_found;
        this.metrics = res
      });
      campaignsService.getCampaignActiveSearching().then((res) => {
        this.loading2 = false;
        this.result = res
        this.searching_rate = res.import_rate.import_rate;
        this.balanceEnrich = res.enrich_credits.balance;
      });
    },
    openTarget(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    isHighStatus(statusItem) {
      return (
        Number(statusItem.business_contact_status_id) === 9 &&
        statusItem.cant > 4000
      );
    },
    isLowSearchingRate(rate) {
      return Number(rate) < 20;
    },
    isLowCampaignsSupplied(campaigns) {
      return Number(campaigns) < 20;
    },
    isLowPendingColdTask(cant){
      return Number(cant) < 1000;
    },
    isLowEnrichCredits(credits){
      return Number(credits) < 40000;
    },
  },
  components: {
    LoadingOliver,
    ContactsSupplyChart
  },
};
</script>

<style>
.alert-danger {
  color: white;
  background-color: red;
}
.alert-success {
  color: white;
  background-color: green;
}
</style>
